import {
  productFamilyImageIdFormat,
  productIdFormat,
  productImageIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const updateVariantListingImages = {
  name: "updateVariantListingImages" as const,
  input: z.object({
    productId: productIdFormat.schema,
    images: z.array(
      z.intersection(
        z.discriminatedUnion("source", [
          z.object({
            source: z.literal("product_family"),
            imageId: productFamilyImageIdFormat.schema,
          }),
          z.object({
            source: z.literal("product"),
            imageId: productImageIdFormat.schema,
          }),
        ]),
        z.object({ position: z.number() }),
      ),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
